import { Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'cygov-skeleton',
  templateUrl: './skeleton.component.html',
  styleUrls: ['./skeleton.component.scss'],
  standalone: false,
})
export class SkeletonComponent implements OnChanges {
  @Input() width = '100%';
  @Input() height = '1rem';
  @Input() radius = '3px';
  @Input() shape: 'rect' | 'circle' | 'spinner' = 'rect';
  @Input() count = 1;
  @Input() gap = '8px';

  blocks: number[] = [0];
  blockStyle: Record<string, string> = {};
  // 'spinner' swaps the shimmer bar for a rotating ring; everything else keeps the shimmer
  blockClass = 'skeleton-block';

  ngOnChanges(): void {
    const total = Math.max(1, Number(this.count) || 1);
    // rebuild only when the length actually changes so *ngFor keeps its existing DOM nodes
    if (this.blocks.length !== total) {
      this.blocks = Array.from({ length: total }, (_, i) => i);
    }
    const isSpinner = this.shape === 'spinner';
    // a spinner is a ring, so like a circle it takes its width for both axes
    const isRound = isSpinner || this.shape === 'circle';
    this.blockClass = isSpinner ? 'skeleton-spinner' : 'skeleton-block';
    this.blockStyle = {
      width: this.width,
      height: isRound ? this.width : this.height,
      'border-radius': isRound ? '50%' : this.radius,
      'margin-bottom': this.gap,
    };
  }
}
